import styled, { css } from 'styled-components'

export const alertStyles = {
  info: css`
    background-color: #D2E1F4;
  `,
  success: css`
    background-color: #DAF2D4;
  `,
  warning: css`
    background-color: #FAECCA;
  `,
  danger: css`
    background-color: #FCE2E7;
  `,
  campaign: css`
    background-color: #DAF2D4;
  `,
  lock: css`
    background-color: #D2E1F4;
  `
}

export const AlertContainer = styled.div`
  margin-bottom: 24px;
  align-items: ${({ type }) => (type === 'campaign' ? 'start' : 'center')};
  padding: 16px;
  display: flex;
  border-radius: 12px;
  gap: 16px;
  width: 100%;
  ${({ type }) => (
    alertStyles[type]
  )}
`

export const Icon = styled.i`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
`
export const Message = styled.span`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 145%;
  color: #555;
  flex: 1;

  strong {
    font-family: 'Open Sans';
    font-weight: 600;
  }
`
export const CloseButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border: none;
  width: 24px;
  height: 24px;
  padding: 0;
  svg path {
    fill: #555;
  }
  &:focus {
    outline: none;
  }
`
